import {
  EnumEstadoFichero,
  EnumEstadoRemit,
  EnumGrupoDocumento,
  EnumTipoDocumento,
  EnumTipoOperacion,
  EnumZonaBalance
} from '../../api'
import { EnumPrecioUnitario } from '../../api/oData/enums/enumPrecioUnitario'
import { EnumRegulatoryReportState } from '../../api/oData/requests/enumRegulatoryReportState'
import { EnumUnidadMedida } from '../../api/oData/enums/enumUnidadMedida'
import { DataTableActionConfiguration } from '../../model'
import { EnumFileStateWithDispatch } from '../../api/Pioneer/enums/enumFileStateWithDispatch'

export interface remitReportPositionModel {
  tradeCode: string
  counterpart?: string
  signDate?: Date
  startDate?: Date
  endDate?: Date
  type: EnumTipoOperacion
  logisticElement?: string
  quantity?: number
  quantityUnit?: string
  quantityWithUnit?: string
  price?: number
  priceUnit?: string
  priceWithUnit?: string
  state?: EnumRegulatoryReportState
}

export interface remitReportOperationModel {
  tradeCode: string
  counterpart?: string
  signDate?: Date
  date?: Date
  type: EnumTipoOperacion
  logisticElement?: string
  quantity?: number
  quantityUnit?: string
  quantityWithUnit?: string
  price?: number
  priceUnit?: string
  priceWithUnit?: string
  state: EnumRegulatoryReportState
}

export interface remitRequestModel {
  operationTypes: EnumTipoOperacion[]
  startDate: string
  endDate: string
  balanceZone?: EnumZonaBalance
  company?: number
  idElemLog?: number
}

export interface remitTableResponseModel {
  tradeCode: string
  counterpart: string
  signDate: Date
  date?: Date
  initDate?: Date
  endDate?: Date
  type: EnumTipoOperacion
  logisticElementId: number
  logisticElementCode: string
  logisticElementDescription: string
  quantity?: number
  quantityUnit: EnumUnidadMedida
  price?: number
  priceUnit?: EnumPrecioUnitario
  state?: EnumEstadoRemit
}

export interface remitLngResponseModel {
  shipDate: Date
  shipCode: string
  sequenceNumber: string
  type: EnumTipoOperacion
  destination: string
  ship: string
  quantity?: number
  state?: EnumEstadoRemit
}

export interface remitStorageResponseModel {
  date: Date
  logisticElementId: number
  logisticElementCode: string
  logisticElementDescription: string
  quantity?: number
  state?: EnumEstadoRemit
}

export interface reportFilesByGroupsRequestModel {
  groupsDocuments: EnumGrupoDocumento[]
  balanceZone?: EnumZonaBalance
  company?: number
}

export interface remitTableResponseModel {
  tradeCode: string
  counterpart: string
  signDate: Date
  date?: Date
  initDate?: Date
  endDate?: Date
  type: EnumTipoOperacion
  logisticElementId: number
  logisticElementCode: string
  logisticElementDescription: string
  quantity?: number
  quantityUnit: EnumUnidadMedida
  price?: number
  priceUnit?: EnumPrecioUnitario
  state?: EnumEstadoRemit
}

export interface remitLngResponseModel {
  shipDate: Date
  shipCode: string
  sequenceNumber: string
  type: EnumTipoOperacion
  destination: string
  ship: string
  quantity?: number
  state?: EnumEstadoRemit
}

export interface remitStorageResponseModel {
  date: Date
  logisticElementId: number
  logisticElementCode: string
  logisticElementDescription: string
  quantity?: number
  state?: EnumEstadoRemit
}

export interface remitStorageReportModel {
  date: Date
  logisticElement?: string
  quantity?: number
  state: EnumRegulatoryReportState
}

export interface remitReportLngModel {
  date: Date
  code: string
  sequenceNumber: string
  type: EnumTipoOperacion
  destination?: string
  ship: string
  quantity?: number
  state: EnumRegulatoryReportState
}

export interface regulatoryReportDownloadCard {
  fileId: number
  fileDate: Date
  fileName?: string
  fileRrm?: string
  fileState?: EnumFileStateWithDispatch
  fileUrl?: string
  urlLog?: string
  documentType?: string
  canDownload: boolean
  actionsConfiguration: Array<DataTableActionConfiguration>
  actions?: any
}

export enum RegulatoryReports {
  REMITTABLE1 = 0,
  REMITTABLE2 = 1,
  REMITSTORAGE = 2,
  REMITLNGACTIVITY = 3,
  REMITLNGPLANNED = 4,
  CNMC = 5,
  CORES = 6
}

export enum RegulatoryReportsPower {
  MINCOTUR = 0,
  CNMC_POWER = 1
}

export enum RegulatoryReportsTypes {
  ESCILA = 1,
  FNEE = 2,
  PRICE = 3,
  CODAGE = 4,
  INFOCLIENTES = 5,
  INFOCONSUMOS = 6,
  CORES = 7
}

export enum LocalReportCardTypes {
  C4 = 0,
  C5 = 1,
  CORES = 2
}

export enum LocalReportCardActions {
  DOWNLOADTEMPLATE = 0,
  GENERATEREPORT = 1
}

export interface RemitFileModel {
  id?: number
  documentType?: EnumTipoDocumento
  description?: string
  documentDate?: Date
  endDate?: Date
  idTransmitterSubjet?: number
  codTransmitterSubject?: string
  transmitterSubject?: string
  idDestinationSubject?: number
  codDestinationSubject?: string
  destinationSubject?: string
  url?: string
  state?: EnumEstadoFichero
  documentGroup?: EnumGrupoDocumento
}

export interface GenerateReportRequest {
  signDateIni?: string
  signDateEnd?: string
  initDate: string
  endDate: string
  type: number
  rRM: number
  infrastructures?: Array<number>
  counterparts?: Array<number>
  cdTrade?: string | null
  sendState?: boolean | null
  company: number
  balanceZone: number
  idElemLog?: number
}

export interface GenerateReportRequestTable1 {
//   signDateIni?: string
//   signDateEnd?: string
//   initDate: string
//   endDate: string
  type: number
  rRM: number
  infrastructures?: Array<number>
  counterparts?: Array<number>
  tradesList: Array<string>
  sendState?: boolean | null
  company: number
  balanceZone: number
  idElemLog?: number
}

export interface GenerateRegulatoryReportRequest {
  reportType: number
  company: number
  idZonaBalance: number
  cif?: string | null
  startDate: string
  endDate: string
  commodity: number
}

export interface GenerateRegulatoryReportAPIRequest
  extends Omit<GenerateRegulatoryReportRequest, 'startDate' | 'endDate'> {
  startDate: string
  endDate: string
}

export interface regulatoryReportResponseModel {
  url?: string | null
  url_log?: string | null
}
